import { render, staticRenderFns } from "./MenuBg.vue?vue&type=template&id=5d0bc762&"
import script from "./MenuBg.vue?vue&type=script&lang=js&"
export * from "./MenuBg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports